import { Cached, Mapper, FirestoreEntity } from '../@harmony';
import {
  DiscoverySource,
  DiscoverySourceEntity,
  DiscoverySourceEntityToDiscoverySourceMapper,
} from '.';

export abstract class DiscoverySourceCommonProvider {
  abstract provideDiscoverySourceEntityToDiscoverySourceMapper(): Mapper<
    FirestoreEntity<DiscoverySourceEntity>,
    DiscoverySource
  >;
}

export class DiscoverySourceCommonDefaultProvider implements DiscoverySourceCommonProvider {
  @Cached()
  public provideDiscoverySourceEntityToDiscoverySourceMapper(): Mapper<
    FirestoreEntity<DiscoverySourceEntity>,
    DiscoverySource
  > {
    return new DiscoverySourceEntityToDiscoverySourceMapper();
  }
}
